import type { VehicleSummary, Vehicle } from '@/types'

/**
 * Vehicle data layer. Re-exported from @/data and used by VehiclesPage, VehicleDetailPage, HomePage, etc.
 * Mock inventory mirrors content from apps/web-customer.
 */
export const VEHICLES: Vehicle[] = [
  {
    id: 'v1',
    vin: '1HGCM82633A123456',
    year: 2024,
    make: 'Honda',
    model: 'Accord',
    trim: 'Sport',
    bodyType: 'sedan',
    mileage: 12500,
    priceCents: 3299900,
    msrpCents: 3599900,
    photos: [
      'https://images.unsplash.com/photo-1619682817481-e994891cd1f5?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Platinum White Pearl',
    interiorColor: 'Black',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'fwd',
    engineDescription: '1.5L Turbo 4-Cylinder',
    mpgCity: 29,
    mpgHighway: 37,
    features: [
      'Apple CarPlay',
      'Android Auto',
      'Honda Sensing Suite',
      'Heated Front Seats',
      'Power Moonroof',
      'LED Headlights',
      'Wireless Charging',
      'Adaptive Cruise Control',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-20T15:30:00Z',
  },
  {
    id: 'v2',
    vin: '5YJSA1E26MF123456',
    year: 2023,
    make: 'Tesla',
    model: 'Model 3',
    trim: 'Long Range',
    bodyType: 'sedan',
    mileage: 18000,
    priceCents: 4199900,
    msrpCents: 4499900,
    photos: [
      'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1554744512-d6c603f27c54?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Midnight Silver Metallic',
    interiorColor: 'White',
    fuelType: 'electric',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: 'Dual Motor All-Wheel Drive',
    features: [
      'Autopilot',
      'Premium Interior',
      '15" Touchscreen',
      'Glass Roof',
      'Premium Audio',
      'Sentry Mode',
      'Supercharger Access',
    ],
    certified: false,
    createdAt: '2024-01-10T10:00:00Z',
    updatedAt: '2024-01-18T15:30:00Z',
  },
  {
    id: 'v3',
    vin: '1G1YY22G965123456',
    year: 2022,
    make: 'Chevrolet',
    model: 'Corvette',
    trim: 'Stingray 3LT',
    bodyType: 'coupe',
    mileage: 8500,
    priceCents: 6999900,
    msrpCents: 7499900,
    photos: [
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Torch Red',
    interiorColor: 'Jet Black',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'rwd',
    engineDescription: '6.2L V8 LT2',
    mpgCity: 15,
    mpgHighway: 27,
    features: [
      'Z51 Performance Package',
      'Performance Exhaust',
      'Magnetic Ride Control',
      'Head-Up Display',
      'Bose Premium Audio',
      'GT2 Bucket Seats',
      'Carbon Fiber Interior',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-15T15:30:00Z',
  },
  {
    id: 'v4',
    vin: '5TDKZ3DC8MS123456',
    year: 2024,
    make: 'Toyota',
    model: 'Highlander',
    trim: 'XLE Hybrid',
    bodyType: 'suv',
    mileage: 5200,
    priceCents: 4499900,
    msrpCents: 4799900,
    photos: [
      'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1606016159991-dfe4f2746ad5?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Celestial Silver Metallic',
    interiorColor: 'Gray',
    fuelType: 'hybrid',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: '2.5L 4-Cylinder Hybrid',
    mpgCity: 36,
    mpgHighway: 35,
    features: [
      'Third Row Seating',
      'Toyota Safety Sense 2.5+',
      'SofTex Trimmed Seats',
      'Power Liftgate',
      'JBL Audio System',
      'Panoramic Moonroof',
      'Digital Rearview Mirror',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-12T10:00:00Z',
    updatedAt: '2024-01-22T15:30:00Z',
  },
  {
    id: 'v5',
    vin: 'WVWZZZ3CZWE123456',
    year: 2023,
    make: 'Volkswagen',
    model: 'ID.4',
    trim: 'Pro S',
    bodyType: 'suv',
    mileage: 11000,
    priceCents: 3899900,
    msrpCents: 4299900,
    photos: [
      'https://images.unsplash.com/photo-1617788138017-80ad40651399?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Dusk Blue Metallic',
    interiorColor: 'Galaxy Black',
    fuelType: 'electric',
    transmission: 'automatic',
    drivetrain: 'rwd',
    engineDescription: 'Single Motor Rear-Wheel Drive',
    features: [
      'IQ.Drive Assistance',
      '12" Touchscreen',
      'Panoramic Glass Roof',
      'Wireless Charging',
      'Heated Steering Wheel',
      '275 Mile Range',
    ],
    certified: false,
    createdAt: '2024-01-08T10:00:00Z',
    updatedAt: '2024-01-19T15:30:00Z',
  },
  {
    id: 'v6',
    vin: 'WBA8E9C55JK123456',
    year: 2021,
    make: 'BMW',
    model: '3 Series',
    trim: '330i xDrive',
    bodyType: 'sedan',
    mileage: 32000,
    priceCents: 3599900,
    msrpCents: 4199900,
    photos: [
      'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Alpine White',
    interiorColor: 'Cognac Vernasca Leather',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: '2.0L TwinPower Turbo 4-Cylinder',
    mpgCity: 26,
    mpgHighway: 36,
    features: [
      'M Sport Package',
      'Navigation Professional',
      'Harman Kardon Audio',
      'Parking Assistant Plus',
      'Heated Front Seats',
      'Live Cockpit Professional',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-03T10:00:00Z',
    updatedAt: '2024-01-14T15:30:00Z',
  },
  {
    id: 'v7',
    vin: '1FTFW1E50MF123456',
    year: 2022,
    make: 'Ford',
    model: 'F-150',
    trim: 'Lariat',
    bodyType: 'truck',
    mileage: 28000,
    priceCents: 5299900,
    msrpCents: 5899900,
    photos: [
      'https://images.unsplash.com/photo-1590656844973-fb86891b7c81?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
    ],
    status: 'pending',
    exteriorColor: 'Antimatter Blue Metallic',
    interiorColor: 'Black',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: '4wd',
    engineDescription: '3.5L EcoBoost V6',
    mpgCity: 18,
    mpgHighway: 24,
    features: [
      'FordPass Connect',
      'SYNC 4',
      'Pro Power Onboard',
      'B&O Sound System',
      'Max Trailer Tow Package',
      '360-Degree Camera',
      'Tailgate Step',
    ],
    certified: false,
    createdAt: '2024-01-02T10:00:00Z',
    updatedAt: '2024-01-13T15:30:00Z',
  },
  {
    id: 'v8',
    vin: 'JN1TBNT32Z0123456',
    year: 2020,
    make: 'Nissan',
    model: 'Altima',
    trim: 'SV',
    bodyType: 'sedan',
    mileage: 45000,
    priceCents: 2199900,
    msrpCents: 2799900,
    photos: [
      'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1542362567-b07e54358753?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Gun Metallic',
    interiorColor: 'Charcoal',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'fwd',
    engineDescription: '2.5L 4-Cylinder',
    mpgCity: 28,
    mpgHighway: 39,
    features: [
      'ProPILOT Assist',
      'Apple CarPlay',
      'Android Auto',
      'Remote Start',
      'Intelligent Around View Monitor',
      'Blind Spot Warning',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-01T10:00:00Z',
    updatedAt: '2024-01-11T15:30:00Z',
  },
  {
    id: 'v9',
    vin: 'WDDZF4KB3KA123456',
    year: 2023,
    make: 'Mercedes-Benz',
    model: 'E-Class',
    trim: 'E 350 4MATIC',
    bodyType: 'sedan',
    mileage: 15000,
    priceCents: 5499900,
    msrpCents: 6299900,
    photos: [
      'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1563720223185-11003d516935?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Obsidian Black Metallic',
    interiorColor: 'Macchiato Beige',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: '2.0L Turbo 4-Cylinder',
    mpgCity: 23,
    mpgHighway: 31,
    features: [
      'MBUX Infotainment',
      'Burmester 3D Surround Sound',
      'Driver Assistance Package',
      '64-Color Ambient Lighting',
      'Air Balance Package',
      'Heated & Ventilated Seats',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-14T10:00:00Z',
    updatedAt: '2024-01-24T15:30:00Z',
  },
  {
    id: 'v10',
    vin: 'JTDKN3DU5A0123456',
    year: 2024,
    make: 'Toyota',
    model: 'Prius',
    trim: 'XLE Premium',
    bodyType: 'hatchback',
    mileage: 3200,
    priceCents: 3699900,
    msrpCents: 3899900,
    photos: [
      'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1619317218416-c68f8a21cc35?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Supersonic Red',
    interiorColor: 'Black SofTex',
    fuelType: 'hybrid',
    transmission: 'automatic',
    drivetrain: 'fwd',
    engineDescription: '2.0L 4-Cylinder Hybrid',
    mpgCity: 57,
    mpgHighway: 56,
    features: [
      'Toyota Safety Sense 3.0',
      '12.3" Multimedia Display',
      'Wireless Charging',
      'Head-Up Display',
      'JBL Premium Audio',
      'Rain-Sensing Wipers',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-20T10:00:00Z',
    updatedAt: '2024-01-25T15:30:00Z',
  },
  {
    id: 'v11',
    vin: '5YJ3E1EA8PF123456',
    year: 2023,
    make: 'Tesla',
    model: 'Model Y',
    trim: 'Performance',
    bodyType: 'suv',
    mileage: 9500,
    priceCents: 4899900,
    msrpCents: 5299900,
    photos: [
      'https://images.unsplash.com/photo-1619317218416-c68f8a21cc35?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Pearl White Multi-Coat',
    interiorColor: 'Black',
    fuelType: 'electric',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: 'Dual Motor Performance AWD',
    features: [
      'Full Self-Driving Capability',
      'Performance Brakes',
      'Lowered Suspension',
      'Premium Connectivity',
      'Glass Roof',
      '303 Mile Range',
    ],
    certified: false,
    createdAt: '2024-01-18T10:00:00Z',
    updatedAt: '2024-01-23T15:30:00Z',
  },
  {
    id: 'v12',
    vin: 'WAUFFAFL8FN123456',
    year: 2022,
    make: 'Audi',
    model: 'A4',
    trim: 'Premium Plus 45 TFSI',
    bodyType: 'sedan',
    mileage: 22000,
    priceCents: 3999900,
    msrpCents: 4599900,
    photos: [
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=500&fit=crop',
      'https://images.unsplash.com/photo-1542362567-b07e54358753?w=800&h=500&fit=crop',
    ],
    status: 'available',
    exteriorColor: 'Navarra Blue Metallic',
    interiorColor: 'Black',
    fuelType: 'gasoline',
    transmission: 'automatic',
    drivetrain: 'awd',
    engineDescription: '2.0L TFSI 4-Cylinder',
    mpgCity: 25,
    mpgHighway: 34,
    features: [
      'Virtual Cockpit Plus',
      'Bang & Olufsen 3D Sound',
      'S Line Sport Package',
      'Matrix LED Headlights',
      'Audi Pre Sense',
      'Heated Front Seats',
    ],
    certified: true,
    carfaxUrl: 'https://www.carfax.com',
    createdAt: '2024-01-16T10:00:00Z',
    updatedAt: '2024-01-21T15:30:00Z',
  },
]

/**
 * Get all vehicles as summaries for list views
 */
export function getVehicleSummaries(): VehicleSummary[] {
  return VEHICLES.map((v) => ({
    id: v.id,
    year: v.year,
    make: v.make,
    model: v.model,
    trim: v.trim,
    priceCents: v.priceCents,
    mileage: v.mileage,
    photo: v.photos[0] || null,
    status: v.status,
    certified: v.certified,
    exteriorColor: v.exteriorColor,
    fuelType: v.fuelType,
    transmission: v.transmission,
    drivetrain: v.drivetrain,
  }))
}

/**
 * Get featured vehicles (certified, available, sorted by newest)
 */
export function getFeaturedVehicles(): VehicleSummary[] {
  return getVehicleSummaries()
    .filter((v) => v.certified && v.status === 'available')
    .slice(0, 6)
}

/**
 * Get a single vehicle by ID
 */
export function getVehicleById(id: string): Vehicle | undefined {
  return VEHICLES.find((v) => v.id === id)
}

/**
 * Get unique makes
 */
export function getMakes(): string[] {
  return [...new Set(VEHICLES.map((v) => v.make))].sort()
}

/**
 * Get body types count
 */
export function getBodyTypeCounts(): Record<string, number> {
  return VEHICLES.reduce((acc, v) => {
    acc[v.bodyType] = (acc[v.bodyType] || 0) + 1
    return acc
  }, {} as Record<string, number>)
}
